    <div id="progress" [ngClass]="{'no-progress': !progress}">
        <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
    <div id="login" *ngIf="showLogin === true; else myOutlet" fxLayout="row" fxLayoutAlign="center center" fxFill>
        <div fxLayout="row" fxLayoutAlign="center center">
            <login-component></login-component>
        </div>
    </div>
    <ng-template #myOutlet>
        <router-outlet></router-outlet>
    </ng-template>
